export default class FormatError extends Error {}
